import { inject, Injectable } from '@angular/core';
import { ApiService } from '@shared/services/api.service';
import { IHyperlink } from '@shared/interfaces/various/IHyperlink';
import { UpdateHyperlink } from '@monorepo/interfaces';

@Injectable({
    providedIn: 'root'
})
export class HyperlinkService {
    private readonly apiUrl = '/hyperlinks';

    private readonly apiService = inject(ApiService);

    public getAllItems(): Promise<IHyperlink[]> {
        return this.apiService.get(this.apiUrl);
    }

    public createItem(item: IHyperlink): Promise<IHyperlink> {
        return this.apiService.post(this.apiUrl, item);
    }

    public updateItem(item: IHyperlink): Promise<IHyperlink> {
        const dto: UpdateHyperlink = {
            title: item.title,
            titleDe: item.titleDe,
            description: item.description,
            descriptionDe: item.descriptionDe,
            urlLink: item.urlLink,
            urlLinkDe: item.urlLinkDe
        };
        return this.apiService.patch(`${this.apiUrl}/${item.id}`, dto);
    }

    public deleteItem(item: IHyperlink): Promise<boolean> {
        return this.apiService.delete(`${this.apiUrl}/${item.id}`);
    }
}
